import { Stroke, Fill, Text, Style } from "ol/style";
//import MultiLineString from "ol/geom/MultiLineString";

import {
  addVectorLayer,
  nearestFeaturePolygons,
  nearestFeatureLineStrings,
} from "./exyztGIS";

import chroma from "chroma-js";

var zonesColor = [];
var sectorColor = [];
function initStyle(zones, secteurs, callback) {
  zones.forEach((row) => {
    zonesColor[row.code] = row.color;
  });

  secteurs.forEach((row) => {
    sectorColor[row.code] = row.color;
  });

  if (typeof callback === "function") {
    callback();
  }
}

var valueTypeColorPlace = {
  NOR: "#008080",
  GIC: "#0000FF",
  BUS: "#e65100",
  LIV: "#fdd835",
  ELC: "#00FF00",
  MOT: "#808000",
  CAR: "#800080",
  VEL: "#800000",
  SSP: "#FF0000",
  TAX: "#ef9a9a",
  TTD: "#aaaaff",
};

var sectorLayer = undefined;
var zoneLayer = undefined;
var parkingLayer = undefined;
var placesParkingLayer = undefined;

function addAlpha(color, opacity) {
  const _opacity = Math.round(Math.min(Math.max(opacity || 1, 0), 1) * 255);
  return color + _opacity.toString(16).toUpperCase();
}

function getStyle(layer) {
  //TODO : put style in memory

  var style = undefined;

  function zoneStyle(feature) {
    var p = feature.getProperties();
    var geom = feature.getGeometry().getType();
    var isLineString = geom === "MultiLineString";

    var c = zonesColor[p.code];
    var alphaColor = c;
    if (c !== undefined) {
      alphaColor = chroma(c).alpha(0.2);
    }

    var style = new Style({
      stroke: new Stroke({
        color: zonesColor[p.code],
        width: 2,
      }),
      fill: new Fill({
        color: alphaColor,
      }),
      text: new Text({
        font: 'bold 14px "Open Sans", "Arial Unicode MS", "sans-serif"',
        //placement: "line",//only for linestring
        offsetY: 10,
        fill: new Fill({
          color: "black",
        }),
        stroke: new Stroke({ color: "white", width: 3 }),
      }),
    });
    if (isLineString) {
      style.getText().setPlacement("line");
    }

    style.getText().setText(p.libelle);
    return [style];
  }

  function sectorStyle(feature) {
    var p = feature.getProperties();

    var c = sectorColor[p.code];
    var alphaColor = c;
    if (c !== undefined) {
      alphaColor = chroma(c).alpha(0.2);
    }

    var style = new Style({
      stroke: new Stroke({
        color: c,
        width: 3,
      }),
      fill: new Fill({
        color: alphaColor,
      }),
      text: new Text({
        font: 'bold 14px "Open Sans", "Arial Unicode MS", "sans-serif"',
        fill: new Fill({
          color: "black",
        }),
        stroke: new Stroke({ color: "white", width: 3 }),
      }),
    });
    style.getText().setText(p.libelle);
    return [style];
  }

  function parkingStyle(feature) {
    var p = feature.getProperties();
    var color = valueTypeColorPlace[p.type];

    var style = new Style({
      stroke: new Stroke({
        color: color, //"darkgrey",
        width: 3,
      }),
      fill: new Fill({
        color: addAlpha(color, 0.2),
      }),
    });
    return [style];
  }

  function placeStyle(feature) {
    // var p = feature.getProperties();

    var selected = feature.get("selected");

    var style = new Style({
      stroke: new Stroke({
        color: selected ? "green" : "teal",
        width: selected ? 4 : 2,
      }),
    });

    return [style];
  }

  if (isSecteurLayer(layer)) {
    style = sectorStyle;
  }
  if (isZoneLayer(layer)) {
    style = zoneStyle;
  }
  if (isParkingLayer(layer)) {
    style = parkingStyle;
  }
  if (isPlacesParkingLayer(layer)) {
    style = placeStyle;
  }

  return style;
}

function isSecteurLayer(layer) {
  return layer.type === "sector";
}

function isZoneLayer(layer) {
  return layer.type === "area";
}

function isParkingLayer(layer) {
  return layer.type === "parking";
}

function isPlacesParkingLayer(layer) {
  return layer.type === "placesParking";
}

async function addLayer(map, layer, featureProjection) {
  var vLayer = await addVectorLayer(
    map,
    layer.name,
    layer.url,
    layer.typeName,
    layer.projection,
    featureProjection,
    layer.bbox,
    layer.authorization,
    layer.geometry !== undefined ? layer.geometry : "geometry",
    getStyle(layer)
  );

  return new Promise((resolve) => {
    if (isSecteurLayer(layer)) {
      sectorLayer = vLayer;
      sectorLayer.setMaxZoom(17);
      sectorLayer.setVisible(false);
    }

    if (isZoneLayer(layer)) {
      zoneLayer = vLayer;
      zoneLayer.setMaxZoom(17);
    }

    if (isParkingLayer(layer)) {
      parkingLayer = vLayer;
      parkingLayer.setMinZoom(17);
    }

    if (isPlacesParkingLayer(layer)) {
      placesParkingLayer = vLayer;
      placesParkingLayer.setMinZoom(17);
    }
    resolve();
  });
}

function addLayers(map, layers, featureProjection) {
  //clean vectors layers
  layers.forEach(function (layer) {
    map.removeLayer(layer);
  });

  var ar = [];
  layers.forEach(function (layer) {
    ar.push(addLayer(map, layer, featureProjection));
  });
  return ar;
}

var nearestFeaturePolygonsFromLayer = function (coordinate, layer) {
  var feature = null;
  if (layer !== undefined) {
    var sectorSource = layer.getSource();
    feature = nearestFeaturePolygons(coordinate, sectorSource.getFeatures());
  }

  return feature;
};

var nearestFeatureLineStringsFromLayer = function (coordinate, layer) {
  var feature = null;

  if (layer !== undefined) {
    var isLineString = layer.get("geometry") === "LineString";

    if (isLineString) {
      feature = nearestFeatureLineStrings(coordinate, layer);
    } else {
      var sectorSource = layer.getSource();
      feature = nearestFeaturePolygons(coordinate, sectorSource.getFeatures());
    }
  }

  return feature;
};

export {
  getStyle,
  isSecteurLayer,
  isZoneLayer,
  isParkingLayer,
  isPlacesParkingLayer,
  initStyle,
  addLayer,
  addLayers,
  nearestFeaturePolygonsFromLayer,
  nearestFeatureLineStringsFromLayer,
  sectorLayer,
  zoneLayer,
  parkingLayer,
  placesParkingLayer,
};
